import { render, staticRenderFns } from "./ListarGrupos.vue?vue&type=template&id=a845b018"
import script from "./ListarGrupos.vue?vue&type=script&lang=js"
export * from "./ListarGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports